export { default } from "./useArticleStoryGet";
